import _ from "lodash";
import Default from "./default.json";
import Eaventer from "./eaventer.json";
import RoundSquare from "./roundsquare.json";

const merge = (target: any, source: any) => {
  // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
  for (const key of Object.keys(source)) {
    if (source[key] instanceof Object)
      Object.assign(source[key], merge(target[key], source[key]));
  }

  // Join `target` and modified `source`
  Object.assign(target || {}, source);
  return target;
};

export const WhiteLabel = _.merge(
  Default,
  document.location.host.includes("eaventer")
    ? Eaventer
    : (document.location.host.includes("localhost") || document.location.host.includes("roundsquare"))
    ? RoundSquare
    : {}
) as typeof Default;
